import { render, staticRenderFns } from "./PoliticaDesconto.vue?vue&type=template&id=c80253ea&scoped=true&"
import script from "./PoliticaDesconto.vue?vue&type=script&lang=js&"
export * from "./PoliticaDesconto.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaDesconto.vue?vue&type=style&index=0&id=c80253ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c80253ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
